import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    list: [],
    meta: {},
    details: {},
};

const animationsSlice = createSlice({
  name: 'animations',
  initialState,
  reducers: {
    createAnimationRequest: () => {},
    getAnimationsRequest: () => {},
    getAnimationsResponse: (state, action) => {
      state.list = action.payload.animations;
      state.meta = action.payload.meta;
    },
    getAnimationDetailsRequest: () => {},
    getAnimationDetailsResponse: (state, action) => {
      state.details = action.payload;
    },
    editAnimationRequest: () => {},
    deleteAnimationRequest: () => {},
    updateActiveStatus: () => {},
  },
});

export const {
  createAnimationRequest,
  getAnimationsRequest,
  getAnimationsResponse,
  getAnimationDetailsRequest,
  getAnimationDetailsResponse,
  editAnimationRequest,
  deleteAnimationRequest,
  updateActiveStatus,
} = animationsSlice.actions;

export default animationsSlice.reducer; 